module.exports = __webpack_public_path__ + "img/dl.88b5c446.png";